import { render } from "./PageHouses.vue?vue&type=template&id=68164417&scoped=true"
import script from "./PageHouses.vue?vue&type=script&lang=js"
export * from "./PageHouses.vue?vue&type=script&lang=js"

import "./PageHouses.vue?vue&type=style&index=0&id=68164417&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68164417"]])

export default __exports__